(function ($) {
  $('.productCategoryHeroComponent-dropdown').on('shown.bs.dropdown', function (e) {
    $(e.target).find("button span").text($(e.target).find("button").data("close"));
  });
  $('.productCategoryHeroComponent-dropdown').on('hidden.bs.dropdown', function (e) {
    $(e.target).find("button span").text($(e.target).find("button").data("original"));
  });
})(jQuery);